import { render } from "./AppCTA.vue?vue&type=template&id=2fcee5aa&scoped=true"
import script from "./AppCTA.vue?vue&type=script&lang=js"
export * from "./AppCTA.vue?vue&type=script&lang=js"

import "./AppCTA.vue?vue&type=style&index=0&id=2fcee5aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcee5aa"]])

export default __exports__